// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";
// import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAk8vuEnhLwkGeNUP1b4-qb0jGWMywAMgI",
  authDomain: "chowdown-web.firebaseapp.com",
  projectId: "chowdown-web",
  storageBucket: "chowdown-web.appspot.com",
  messagingSenderId: "903091185642",
  appId: "1:903091185642:web:6f7a8f53006ad6769c7493",
  measurementId: "G-EW76D6J7N0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// export const auth = getAuth(app);
export const db = getFirestore(app);
// export const storage = getStorage(app);
// export const functions = getFunctions(app);
